// Função para alternar a visibilidade da sidebar
function toggleSidebar() {
  const sidebarWrapper = document.getElementById('sidebarWrapper');
  const overlay = document.getElementById('overlay');
  const loginSidebar = document.getElementById('loginSidebar');

  // Alterna a visibilidade da div que engloba overlay e sidebar
  if (sidebarWrapper.style.display === 'none') {
    sidebarWrapper.style.display = 'flex';
    overlay.style.display = 'flex';
    loginSidebar.style.display = 'flex';
  } else {
    sidebarWrapper.style.display = 'none';
    overlay.style.display = 'none';
    loginSidebar.style.display = 'none';
  }
}

// Adicionar evento de clique ao overlay
document.getElementById('overlay').addEventListener('click', toggleSidebar);

// Impedir que o clique dentro do modal feche o modal
document.getElementById('loginSidebar').addEventListener('click', function (event) {
  event.stopPropagation();
});

// Observar mudanças no DOM para adicionar tabindex e eventos de teclado
const domObserver = new MutationObserver((_mutationList, observer) => {
  const hikoContainer = document.querySelector('[name="hiko-container"]');

  if (hikoContainer) {
    const buttons = hikoContainer.querySelectorAll('.h_buttons > div');

    buttons.forEach(button => {
      if (!button.hasAttribute('tabindex')) {
        button.setAttribute('tabindex', '0');
      }

      button.addEventListener('keyup', function(event) {
        if (event.key === 'Enter' || event.keyCode === 13) {
          button.click();
        }
      });
    });
  }
});

domObserver.observe(document.body, { childList: true, subtree: true });

// Seleciona o botão que você quer que acione o clique
const googleBtn = document.getElementById('google-btn');

// Seleciona o botão que tem a ação desejada
const googleButton = document.getElementById('google-button');

// Adiciona um evento de clique ao botão
if (googleBtn && googleButton) {
  googleBtn.addEventListener('click', function() {
    // Simula o clique no outro botão
    googleButton.click();
  });
}